var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"logo-wrapper"},[_c('img',{staticClass:"logo",attrs:{"src":_setup.logo,"alt":"Logo"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }